import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States

import {
  apiError,
  getManagers,
  managersSuccessful,
  managerbyIdSuccessful,
  isModelVisible,
} from "./ManagersSlice";

// AUTH related methods
import {
  postAdd,
  getList,
  getParamsList,
  postEdit,
  patchEdit,
  postDelete,
} from "../../../helpers/Helper";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";

function* managersList({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(
      getParamsList,
      "/permissions/managers/",
      params
    );
    yield put(managersSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* addManager({ payload }) {
  try {
    if (payload.id == 0) {
      const response = yield call(postAdd, "/permissions/managers/", payload);

      if (response.status == 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Manager Added Successfully.!
              </p>
            </div>
          ),
        });
        yield put(isModelVisible(false));
        yield put(getManagers({ page: 1, search: "", page_size: 10 }));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to add Manager. Please try again!
              </p>
            </div>
          ),
        });
      }
    } else {
      const response2 = yield call(
        postEdit,
        "/permissions/managerss/" + payload.id,
        payload
      );

      if (response2.status == 200) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Manager Edited Successfully.!
              </p>
            </div>
          ),
        });
        yield put(isModelVisible(false));
        yield put(getManagers({ page: 1, search: "", page_size: 10 }));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit Manager. Please try again!
              </p>
            </div>
          ),
        });
      }
    }
  } catch (errors) {
    yield put(apiError(errors));
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
  }
}
function* getManagerbyId({ payload }) {
  try {
    const response = yield call(
      getList,
      "/permissions/managerss/" + payload,
      {}
    );
    yield put(managerbyIdSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}
function* deleteManager({ payload }) {
  try {
    const response = yield call(
      postDelete,
      "/permissions/managerss/" + payload
    );

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your Manager has been deleted!
            </p>
          </div>
        ),
      });
      yield put(getManagers());
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Your Manager has been not deleted!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });

    yield put(apiError(error));
  }
}

export function* watchGetManagers() {
  yield takeEvery("managers/getManagers", managersList);
}
export function* watchManagerAdd() {
  yield takeEvery("managers/managerAdd", addManager);
}
export function* watchManagerbyId() {
  yield takeEvery("managers/managerbyId", getManagerbyId);
}
export function* watchManagerDelete() {
  yield takeEvery("managers/managerDelete", deleteManager);
}

function* ManagersSaga() {
  yield all([
    fork(watchGetManagers),
    fork(watchManagerAdd),
    fork(watchManagerbyId),
    fork(watchManagerDelete),
  ]);
}

export default ManagersSaga;
